import { Type } from 'class-transformer';
import {
	IsArray,
	IsBoolean,
	IsIn,
	IsInt,
	IsOptional,
	IsString,
	MaxLength,
	Min,
	ValidateNested,
} from 'class-validator';
import {
	ORDER_NOTE_TYPE_LABEL_MAX_LENGTH,
	OrderNoteType,
	type ResolvedOrderNoteTypeModel,
} from '../../constants/order-note-types';

/**
 * PD-15892 — one note type as Settings > Order Notes saves it. The screen
 * always sends every type with its full state; the server stores a row only
 * for the types that differ from the code default.
 */
export class OrderNoteTypeConfigInputDto {
	@IsString()
	@IsIn(Object.values(OrderNoteType))
	public noteType!: OrderNoteType;

	@IsBoolean()
	public isVisible!: boolean;

	/** The tenant's name for the type; empty or null keeps the default. */
	@IsString()
	@MaxLength(ORDER_NOTE_TYPE_LABEL_MAX_LENGTH)
	@IsOptional()
	public labelOverride?: string | null;

	/** Zero-based position in the list. */
	@IsInt()
	@Min(0)
	public sortOrder!: number;
}

/** PUT /api/order-note-types body. */
export class UpdateOrderNoteTypesDto {
	@IsArray()
	@ValidateNested({ each: true })
	@Type(() => OrderNoteTypeConfigInputDto)
	public types!: Array<OrderNoteTypeConfigInputDto>;
}

export type GetOrderNoteTypesResponseDto =
	| { success: true; data: Array<ResolvedOrderNoteTypeModel> }
	| { success: false; error: string };

export type UpdateOrderNoteTypesResponseDto =
	| { success: true; data: Array<ResolvedOrderNoteTypeModel> }
	| { success: false; error: string };
